export type GeoPermissionState = "granted" | "denied" | "prompt" | "unknown";

/**
 * Current geolocation permission, without triggering a system prompt.
 *
 * "prompt" means the ask has not been resolved yet, so it is the only state
 * where priming the user with an explanation is worth doing. Browsers that do
 * not expose the Permissions API return "unknown", which callers treat like
 * "prompt" (they show what they showed before this existed).
 */
export async function getGeolocationPermissionState(): Promise<GeoPermissionState> {
  try {
    if (typeof navigator === "undefined" || !navigator.permissions?.query) return "unknown";
    const status = await navigator.permissions.query({ name: "geolocation" as PermissionName });
    if (status.state === "granted" || status.state === "denied" || status.state === "prompt") {
      return status.state;
    }
    return "unknown";
  } catch {
    return "unknown";
  }
}

/** True when the user has already granted or denied, so no priming is needed. */
export function isResolved(state: GeoPermissionState): boolean {
  return state === "granted" || state === "denied";
}
